<template>
  <div class="form-dynamix">

    <div class="columns is-gapless is-centered is-multiline" style="margin-bottom:0;" v-if="!isPrint && !noPrint">
      <div class="column is-12 has-text-right">
        <a v-if="!isIE" :href="('/' + $route.name + '?type=' + type + '&print=true')" target="_blank">
          <span style="font-size:11px;">Printer Friendly</span>&nbsp;&nbsp;
          <img src="../assets/location-icon.png" width="18" style="width:18px;vertical-align:middle;" class="img-responsive" />
        </a>
        <a v-else :href="isPrintPdf" target="_blank">
          <span style="font-size:11px;">Printer Friendly</span>&nbsp;&nbsp;
          <img src="../assets/location-icon.png" width="18" style="width:18px;vertical-align:middle;" class="img-responsive" />
        </a>
      </div>
    </div>

    <div class="columns is-gapless is-centered is-multiline" style="margin-bottom:0;">
      <div v-for="(item, index) in items" class="column" :class="[{ 'is-12': !item.attributes.column }, item.attributes.column]">

        <div class="field">
          <div class="control has-icons-right">
            <!-- checkbox / radio label & default checkbox -->
            <p v-if="(item.attributes.type === 'checkbox' || item.attributes.type === 'radio')" class="label">
              <span v-if="item.attributes.title && !item.attributes.withDefault && !item.attributes.titleHidden">
                {{ item.attributes.title + (vuelidate.models[item.name].$params.hasOwnProperty('required') || vuelidate.models[item.name].$params.hasOwnProperty('required_custom') ? ' *' : '') }}
              </span>
              <label v-if="item.attributes.type === 'checkbox' && item.attributes.withDefault === true"
                :class="[item.attributes.type]" class="label default"><!-- key="option.value" -->
                <input type="checkbox" :name="[item.name]"
                  v-model="models[item.name]" v-if="!item.attributes.withDefaultHideInput"
                  @clicked="item.attributes.onChecked()" />
                {{ item.attributes.title + (vuelidate.models[item.name].$params.required ? ' *' : '') }}
              </label>
              <!-- <span>{{ models[item.name] }}</span> -->
            </p>

            <!-- dropdown -->
            <div v-if="item.attributes.type === 'dropdown'" class="select">
              <select :class="[{ 'is-danger': vuelidate.models[item.name].$dirty && (models[item.name] == undefined || models[item.name] == 0 || models[item.name].length <= 0) && (vuelidate.models[item.name].$params.required && !vuelidate.models[item.name].required) }]"
              v-model="models[item.name]">
                <option v-for="option in item.attributes.options"
                  :value="option.value"><!-- key="option.value" -->
                  {{ option.value !== undefined ? option.title : (option.title + (vuelidate.models[item.name].$params.required ? ' *' : '')) }}
                </option>
              </select>
            </div>

            <!-- checkbox / radio -->
            <label v-else-if="item.attributes.type === 'checkbox' || item.attributes.type === 'radio'" v-for="option in item.attributes.options" :class="[item.attributes.type]"><!-- key="option.value" -->
              <input v-if="item.attributes.type === 'checkbox'" type="checkbox"
                :name="[item.name + '-' + item.value]"
                v-model="models[item.name][option.value]"
                @clicked="item.attributes.onChecked()" />
              <input v-else-if="item.attributes.type === 'radio'" type="radio"
                :name="[item.name + '-' + item.value]"
                v-model="models[item.name]"
                :value="option.value" />
              <span>{{ option.title }}</span>
            </label>

            <!-- text area -->
            <textarea v-else-if="item.attributes.type === 'textarea'"
              v-model.trim="models[item.name]"
              @input="if(item.attributes.onInput) item.attributes.onInput(models[item.name], item.attributes);"
              :placeholder="[item.attributes.title + (vuelidate.models[item.name].$params.required ? ' *' : '')]"
              :maxlength="item.attributes.maxLength"
              class="textarea"
              :class="[{ 'is-danger': vuelidate.models[item.name].$invalid && vuelidate.models[item.name].$dirty }]" >
            </textarea>

            <!-- text -->
            <label v-else-if="item.attributes.type === 'text'" :class="[item.attributes.type]">
              <!-- <span>{{ item.attributes.title }}</span> -->
              <input
                v-model="models[item.name]"
                :placeholder="[item.attributes.title + (vuelidate.models[item.name].$params.required ? ' *' : '')]"
                :disabled="item.attributes.disabled"
                class="input"
                :class="[{ 'is-danger': vuelidate.models[item.name].$invalid && vuelidate.models[item.name].$dirty }]" /> <!--@input="vuelidate.models.email.$touch()"-->
            </label>

            <!-- label -->
            <p v-else-if="item.attributes.type === 'label'" class="label">
              <span v-html="item.attributes.title">{{ item.attributes.title }}</span>
            </p>

            <!-- custom image -->
            <!-- <p v-else-if="item.attributes.type === 'image' && isDesktop" class="image-wrapper" style="text-align:center;">
              <lightbox v-if="!isIE" class="lightbox-wrapper" :caption="''" :src="item.attributes.link" :album="'full_album'">
                <img :src="item.attributes.link" class="img-responsive" />
                <span style="color:gray;font-size:0.8em;">(click to enlarge)</span>
              </lightbox>
              <a v-else class="lightbox-wrapper" :href="item.attributes.link" target="_blank">
                <img :src="item.attributes.link" class="img-responsive" />
                <span style="color:gray;font-size:0.8em;">(click to view in new tab)</span>
              </a>
            </p>
            <p v-else-if="item.attributes.type === 'image' && !isDesktop" class="image-wrapper" style="text-align:center;">
              <a :href="item.attributes.link" target="_blank">
                <img :src="item.attributes.link" class="img-responsive" />
                <span style="color:gray;font-size:0.8em;">(click to view in new tab)</span>
              </a>
            </p> -->
            <p v-else-if="item.attributes.type === 'image'" class="image-wrapper" style="text-align:center;">
              <!-- duplicated control must tally -->
              <a :href="item.attributes.link" target="_blank">
                <img :src="item.attributes.link" class="img-responsive" />
                <span style="color:gray;font-size:0.8em;">(click to view in new tab)</span>
              </a>
            </p>

            <!-- upload -->
            <p v-else-if="item.attributes.type === 'upload'" class="upload-wrapper" style="text-align:center;">
              <form-upload v-if="!isRerender" :vuelidate="vuelidate" v-model="models[item.name]" :is-dirty="vuelidate.models[item.name].dirty" :is-required="vuelidate.models[item.name].required"  @files-changed="onFilesChanged" @files-error="onFilesError"></form-upload>
            </p>

            <!-- invalid -->
            <p v-else class="label-invalid">
              Invalid field.
            </p>

            <!-- warn icon -->
            <span v-if="vuelidate.models[item.name].$dirty && vuelidate.models[item.name].$invalid" class="icon is-small is-right is-danger">
              <i class="fa fa-warning"></i>
            </span>
            <small v-if="item.attributes.type === 'text-area'" class="help counter">{{ item.attributes.curLength }} / {{ item.attributes.maxLength }}</small>
            <p v-if="item.attributes.note" class="help is-note" v-html="item.attributes.note" />
            <p v-if="vuelidate.models[item.name].$dirty && vuelidate.models[item.name].$invalid && vuelidate.models[item.name].$params.required && !vuelidate.models[item.name].required" class="help is-danger">"{{ item.attributes.title }}" is required.</p>
            <p v-if="vuelidate.models[item.name].$dirty && vuelidate.models[item.name].$invalid && vuelidate.models[item.name].$params.numeric && !vuelidate.models[item.name].numeric" class="help is-danger">"{{ item.attributes.title }}" must be numeric value.</p>
            <p v-if="vuelidate.models[item.name].$dirty && vuelidate.models[item.name].$invalid && vuelidate.models[item.name].$params.between && !vuelidate.models[item.name].between" class="help is-danger">"{{ item.attributes.title }}" must be between {{ vuelidate.models[item.name].$params.between.min }} and {{ vuelidate.models[item.name].$params.between.max }}.</p>
            <p v-if="vuelidate.models[item.name].$dirty && vuelidate.models[item.name].$invalid && vuelidate.models[item.name].$params.minLength && !vuelidate.models[item.name].minLength" class="help is-danger">"{{ item.attributes.title }}" is too short.</p>
            <p v-if="vuelidate.models[item.name].$dirty && vuelidate.models[item.name].$invalid && vuelidate.models[item.name].$params.maxLength && !vuelidate.models[item.name].maxLength" class="help is-danger">"{{ item.attributes.title }}" is too long.</p>
            <p v-if="vuelidate.models[item.name].$dirty && vuelidate.models[item.name].$invalid && vuelidate.models[item.name].$params.email && !vuelidate.models[item.name].email" class="help is-danger">{{ item.attributes.title }} is invalid.</p>
            <p v-if="vuelidate.models[item.name].$dirty && vuelidate.models[item.name].$invalid && vuelidate.models[item.name].$params.hasOwnProperty('required_custom') && !vuelidate.models[item.name].required_custom" class="help is-danger">"{{ item.attributes.title }}" selection with at least one option.</p>
            <p v-if="vuelidate.models[item.name].$dirty && vuelidate.models[item.name].$invalid && vuelidate.models[item.name].$params.hasOwnProperty('either_custom') && !vuelidate.models[item.name].either_custom" class="help is-danger">"{{ item.attributes.title }}" selection with conflicting option, please revise.</p>
          </div>
        </div>

      </div>
    </div>

    <!-- <b-field>
      <b-input maxlength="5" type="textarea" placeholder="Message" v-model.trim="message" @input="vuelidate.message.$touch()"></b-input>
    </b-field> -->

    <b-field style="width:100%;margin-bottom:0;" v-if="!isPrint">
      <div class="columns is-gapless is-flex-mobile is-vcentered">
        <div class="column captcha-image-wrapper">
          <vue-recaptcha v-if="!isRerender" :sitekey="recaptchaKey" @verify="onVerifyRecaptcha" @expired="onExpiredRecaptcha" @render="onRenderRecaptcha"></vue-recaptcha>
          <input type="hidden" v-model.trim="models['recaptcha']" />
          <p v-if="vuelidate.models['recaptcha'] && vuelidate.models['recaptcha'].$dirty && vuelidate.models['recaptcha'].$invalid && vuelidate.models['recaptcha'].$params.required && !vuelidate.models['recaptcha'].required" class="help is-danger">Invalid recaptcha.</p>
        </div>
      </div>
    </b-field>

    <b-field class="submit-wrapper" v-if="!isPrint">
      <!-- this must tally with duplicated control -->
      <button class="control button is-outlined" :class="{ 'is-loading': loading }" @click="onSend(vuelidate)">
        <p>{{ loading ? '&nbsp;' : 'SUBMIT' }}</p>
      </button>
    </b-field>

    <p style="text-align:center;" v-if="feedback" class="help is-danger">{{ feedback }}</p>
  </div>
</template>

<script type="text/javascript">
import EventBus from '@/controllers/EventBus'
import DivContainer from '@/components/DivContainer'
import VueRecaptcha from 'vue-recaptcha'
import Singulo from '@/apis/Singulo'
import Lightbox from 'vue-lightbox'
import FormUpload from '@/components/FormUpload'

export default {
  name: 'section-sign-up-team',
  components: {
    DivContainer,
    Lightbox,
    VueRecaptcha,
    FormUpload
  },
  watch: {
  },
  props: [
    'type',
    'feedback',
    'loading',
    'names',
    'models',
    'attributes',
    'vuelidate',
    'no-print', // disable print function
    'is-print', // check if current state is printable
    'is-print-pdf',
    'is-rerender'
  ],
  data: function () {
    return {
      isDesktop: true,
      isIE: EventBus.detectIE(),
      items: [],
      // captcha: '', // use back model's captcha for validation
      captchaImage: undefined,
      session: '',
      recaptchaKey: '6LfeGUAUAAAAAJO6iFz_2d4E0hWiyJ7B6K7k6QsG',
      // feedback: false, // capture from external due to send function
      // loading: false,
      navEmail: EventBus._data._navEmail
    }
  },
  created: function () {
    // console.log('FormDynamix:created(): $v / models')
    // console.log(this.vuelidate)
    // console.log(this.models)
    this.init()
  },
  mounted: function () {
    // on event resize
    this.isDesktop = EventBus._isDesktop
    EventBus.$on('isDesktopChanged', function () {
      this.isDesktop = EventBus._isDesktop
    }.bind(this))

    // this.onRecaptcha(data => {
    //   this.captchaImage = data.data
    //   this.session = data.id
    // })

    // console.log('FormDynamix:mounted(): $v / models')
    // console.log(this.vuelidate)
    // console.log(this.models)
  },
  methods: {
    init: function () {
      // console.log('FormDynamix:init()')
      if (this.vuelidate) {
        if (this.vuelidate.models) {
          for (var i = 0; i < this.names.length; i++) {
            var name = this.names[i]
            if (this.vuelidate.models[name]) {
              if (!this.attributes[name]) {
                this.$set(this.attributes, name, {
                  type: 'text',
                  title: 'Invalid'
                })
              }

              // assign default type
              if (this.attributes[name] && !this.attributes[name].type) {
                this.attributes[name].type = 'text'
              }
              // if (this.attributes[name] && !this.attributes[name].title) {
              //   this.attributes[name].title = 'Invalid'
              // }

              // text area custom type
              if (this.attributes[name] && this.attributes[name].type === 'textarea') {
                if (!this.attributes[name].hasOwnProperty('onInput')) {
                  this.attributes[name].onInput = function (model, params) {
                    if (model) {
                      params.curLength = model.length
                    }
                  }
                }
                if (!this.attributes[name].curLength) {
                  this.attributes[name].curLength = 0
                }
                if (!this.attributes[name].maxLength) {
                  this.attributes[name].maxLength = 500
                }
              }

              // check box custom type
              if (this.attributes[name] && this.attributes[name].type === 'checkbox') {
              }

              // console.log('initializing:' + name)
              // console.log(this.attributes[name])
              this.$set(this.vuelidate.models[name], 'name', name)
              this.$set(this.vuelidate.models[name], 'attributes', this.attributes[name])
              this.items.push(this.vuelidate.models[name])
            }
          }
        }
      }
    },
    onRecaptcha: function (onRecaptchaSuccess) {
      Singulo.getRecaptcha()
      .then(data => {
        // console.log('get recaptcha')
        // console.log(data)
        if (onRecaptchaSuccess) {
          onRecaptchaSuccess(data)
        }
      })
      .catch(error => {
        console.error('get recaptcha error', error)
      })
    },
    onRenderRecaptcha: function (id) {
      this.$emit('recaptcha', { status: 'init' })
    },
    onExpiredRecaptcha: function () {
      this.$emit('recaptcha', { status: 'expired' })
    },
    onVerifyRecaptcha: function (response) {
      // console.log(response)
      if (response && response.length > 0) {
        this.$emit('recaptcha', { status: 'ok', response: response })
      }
    },
    onResetRecaptcha: function () {
      this.$refs.recaptcha.reset()
      this.$emit('recaptcha', { status: 'reset' })
    },
    onApplicationChanged: function (applicationType) {
      console.log('application type changed: ' + applicationType)
    },
    onFilesChanged: function (data) {
      // console.log('-- onFilesChanged --')
      // console.log(data)
      this.$emit('files-changed', data)
      // update model
      if (data.fieldName) {
        // this.models[data.fieldName] = data.files
        if (data.files && data.files.length > 0) {
          this.models[data.fieldName] = data.files
          this.$set(this.models, data.fieldName, data.files)
        } else {
          this.models[data.fieldName] = undefined
          this.$set(this.models, data.fieldName, undefined)
        }
      }
    },
    onFilesError: function (error) {
      // console.log('-- onFilesError --')
      // console.log(error)
      this.$emit('files-error', error)
    },
    onSend: function (vuelidate) {
      vuelidate.models.$touch()
      // var _self = this
      // console.log(vuelidate)
      // console.log(this.models)
      this.$emit('send', { vuelidate: vuelidate, models: this.models, session: this.session, captcha: this.models.captcha })
    }
  }
}
</script>

<style lang="scss">
@import "../styles/app_setting.scss";

.form-dynamix {
  margin-top: 0;
  // padding: 0rem 0.75rem;

  // spaces between divs
  margin-left: 0px;
  @media screen and (min-width: $tablet) {
    margin-left: 15px;
  }
  .columns.is-gapless > .column {
    padding-right: 0px;
    @media screen and (min-width: $tablet) {
      padding-right: 15px;
    }
  }

  @media screen and (min-width: $desktop) {
    padding: 0;
  }
  .field {
  }

  .control {
    margin-top: 0;
    margin-bottom: 15px;

    &.has-icons-right {
      .icon {
        &.is-right {
        }

        &.is-danger {
          color: $color-red !important;
        }
      }
    }

    // control label
    p.label {
      padding-top: 5px;
      padding-left: 15px;
      font-size: 0.9rem;
      color: $color-black;
    }
    p:not(:last-child) {
      margin-bottom: 0;
    }
  }

  .help {
    padding-left: 15px;
    padding-top: 2px;
    margin-bottom: 2px;

    &.is-danger {
      color: $color-red;
      // &:first-letter {
      //   text-transform: uppercase;
      // }
      // text-transform: lowercase;
    }
  }

  &>p {
    // for feedback field only
    margin-top: 1rem;
    color: $color-gray-mid;
    text-align: center;
    font-weight: bold;
    @media screen and (min-width: $desktop) {
      text-align: left;
    }
  }

  // span {
  //   display: block;
  // }

  .captcha-image-wrapper {
    .captcha-image {
      height: 3.6em;
      margin-top: 15px;
      margin-bottom: 0px;
      margin-left: auto;
      margin-right: auto;
    }

    text-align: center;

    & > div {
      margin: auto; // auto to center
      @media screen and (min-width: $desktop) {
        margin: auto; // auto to center
      }
      margin-top: 0; // captcha top margin
      // margin-left: 0;
      & > div {
        margin: auto; // auto to center
        @media screen and (min-width: $desktop) {
          margin: auto; // auto to center
        }
        // margin-left: 0px;
        // @media screen and (min-width: $desktop) {
        //   margin-left: 30px;
        // }
      }
    }
  }

  .captcha-text-wrapper {
    padding-right: 0px;
    @media screen and (min-width: $desktop) {
      padding-right: 15px;
    }
  }

  .submit-wrapper {
    width: 100%;
    margin: auto; // auto to center
    margin-top: 15px;
    padding-right: 0px;
    @media screen and (min-width: $desktop) {
      width: 50%;
      padding-right: 15px;
    }
  }

  input, textarea, select {
    // border: 0;
    font-size: 0.8em;
    box-shadow: none;
    background: transparent;
    border: 1px solid #bbbbbb;
    color: $color-white;

    height: 3em;
    padding-left: 15px;
    padding-right: 15px;

    &[name='captcha'] {
      padding-left: 5px;
      padding-right: 5px;
      @media screen and (min-width: $desktop) {
        padding-left: 15px;
        padding-right: 15px;
      }
    }

    &::placeholder {
      color: #999999;
    }
    &:focus, &.is-focused, &:active, &.is-active {
      border-color: $color-white;
      background: rgba(255,255,255,0.1);
    }

    &.is-danger {
      border-color: $color-red;
    }

    &[disabled] {
      background-color: $color-gray-light;
    }
  }

  .select {
    width: 100%;

    select {
      width: 100%;
    }

    &:hover {
      &:not(.is-multiple)::after {
        border-top: 10px solid $color-black;
      }
    }

    &:not(.is-multiple)::after {
      width: 0;
      height: 0;
      border: 0;
      border-left: 10px solid transparent;
      border-right: 10px solid transparent;
      border-top: 10px solid $color-red;
      transform: rotate(0deg);
      margin-top: -0.2em;
    }
  }

  textarea {
    height: auto;
    @media screen and (min-width: $tablet) {
      height: 120px;
    }
  }

  button {
    border-radius: 0;
    // border: 2px solid $color-gray-mid;
    font-size: 0.8em;
    font-weight: bold;
    background-color: $color-red;
    width: 100%;
    height: auto;
    padding-top: 12px;
    padding-bottom: 12px;
    -webkit-transition: all 0.2s ease-in-out 0s;
    transition: all 0.2s ease-in-out 0s;
    opacity: 1;
    flex-direction: column;

    & p {
      color: $color-white;
    }

    &:after {
      border-color: $color-gray-mid;
      border-right-color: transparent;
      border-top-color: transparent;
    }

    @media screen and (min-width: $desktop) {
      // width: 150px;
      // height: auto;
      // padding-top: 12px;
      // padding-bottom: 12px;
    }

    &:hover {
      background-color: $color-gray;
      -webkit-transition: all 0.2s ease-in-out 0s;
      transition: all 0.2s ease-in-out 0s;
      & p {
        color: #fff;
      }
    }
  }

  .checkbox, .radio {
    color: $color-black;
    font-size: 1em;

    input[type=checkbox], input[type=radio] {
      height: 24px;
      display: inline-block;
      vertical-align: middle;
      margin: 2px 2px 2px 3em;
    }

    &.default {
      input[type=checkbox] {
        margin: 2px 2px 2px 0px;
      }
    }

    span {
      font-size: 0.9em;
    }
  }

  .image-wrapper {
    .lightbox-wrapper {
    }
  }

  .label-invalid {
    border: 1px solid $color-gray-light;
    background-color: white;
    font-size: 0.9em;
    padding: 15px;
  }
}
</style>



// WEBPACK FOOTER //
// FormDynamix.vue?36d01148